// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDcfLx9SZJaWYwBK7eEUtYErB_sBHfZ2To",
  authDomain: "gomarkets.dev",
  projectId: "go-markets-dev",
  storageBucket: "go-markets-dev.appspot.com",
  messagingSenderId: "85304127986",
  appId: "1:85304127986:web:a03ee482311eb77c49fb6b",
  measurementId: "G-EG8SGJS95B",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const storage = getStorage(app);
const analytics = getAnalytics(app);
var database = getDatabase(app);
const auth = getAuth(app);

const firebaseInit = { analytics, storage, database, auth };

export default firebaseInit;
